<div class="estudiante-card">
    <div class="card-header">
      <div class="nro-libreta"><i class="fas fa-hashtag"></i> {{ estudiante.nroLibreta }}</div>
      <app-cinturon-graphics 
        [graduacion]="graduacionActual" 
        [isLoading]="isLoadingGraduacion"
        size="medium">
      </app-cinturon-graphics>
    </div>
    <div class="card-body">
      <h3>{{ estudiante.apellido }}, {{ estudiante.nombre }}</h3>
      
      <!-- Combined cinturon and date in a flex container -->
      <div class="cinturon-container">
        <p class="cinturon">{{ getGraduacionDescripcion() }}</p>
        <p class="info date-info" *ngIf="estudiante.fcUltimoExamen && isValidDate(estudiante.fcUltimoExamen)">
          <i class="fas fa-calendar-check"></i>{{ estudiante.fcUltimoExamen | date:'dd/MM/yyyy' }}
        </p>
      </div>
      
      <p class="info">
        <i class="fas fa-id-card"></i> {{ estudiante.documento || 'Sin documento' }}
      </p>
      <p class="info" *ngIf="estudiante.fcNacimiento && isValidDate(estudiante.fcNacimiento)">
        <i class="fas fa-birthday-cake"></i> {{ estudiante.fcNacimiento | date:'dd/MM/yyyy' }}
      </p>
      <p class="info" *ngIf="!estudiante.fcNacimiento || !isValidDate(estudiante.fcNacimiento)">
        <i class="fas fa-birthday-cake"></i> Sin fecha
      </p>
      
      <!-- Instructor information -->
      <p class="info instructor-info" *ngIf="instructorNombre">
        <i class="fas fa-user-tie"></i> {{ instructorNombre }}
      </p>
      <p class="info instructor-info" *ngIf="!instructorNombre">
        <i class="fas fa-user-tie"></i> Sin instructor
      </p>
      
      <!-- Centro de entrenamiento information -->
      <p class="info centro-info" *ngIf="centroNombre">
        <i class="fas fa-map-pin"></i> {{ centroNombre }}
      </p>
      <p class="info centro-info" *ngIf="!centroNombre">
        <i class="fas fa-map-pin"></i> Sin centro
      </p>
    </div>
    <div class="card-footer">
      <button class="btn-detail" (click)="onViewDetail()">
        <i class="fas fa-eye"></i> Ver detalle
      </button>
    </div>
</div>